module.exports = function(ctx) {
var __t, __p = '';
__p += '<div>\n	<div ref="' +
((__t = (ctx.nestedKey)) == null ? '' : __t) +
'">\n		' +
((__t = ( ctx.children )) == null ? '' : __t) +
'\n	</div>\n	<footer class="modal-footer d-flex justify-content-start">\n		<button class="btn btn-primary" ref="dialogPullCreditButton">Pull Credit</button>\n	</footer>\n</div>\n';
return __p
}